import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import SettingsSidebar from "../../layouts/SettingsSidebar";
import Select from "react-select";
import { Form, Field } from "react-final-form";
import { useEffect, useState } from "react";
import axios from "axios";
import PhoneInput from "react-phone-number-input";

const required = (value) => (value ? undefined : "Required");
const CompanySettings = () => {
  const [initialValues, setInitialValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [currencyOptions, setCurrencyOptions] = useState([]);

  useEffect(() => {
    const fetchCurrencyOptions = async () => {
      try {
        const res = await axios.get("/customers/currency-list/");
        setCurrencyOptions(res.data);
      } catch (err) {
        // handle error as needed
      }
    };
    fetchCurrencyOptions();
  }, []);
  useEffect(() => {
    const fetchCompanySettings = async () => {
      try {
        const res = await axios.get("/accounts/api/settings/company/");
        setInitialValues(res.data);
      } catch (err) {
        // handle error as needed
      } finally {
        setLoading(false);
      }
    };
    fetchCompanySettings();
  }, []);
  const Error = ({ name }) => (
    <Field
      name={name}
      subscription={{ error: true, touched: true }}
      render={({ meta: { error, touched } }) =>
        error && touched ? (
          <span style={{ color: "red", fontSize: "12px" }}>{error}</span>
        ) : null
      }
    />
  );
  const csrftoken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
  const onSubmit = async (values) => {
    try {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key === "currency_type" && value?.value) {
          formData.append(key, value.value);
        } else {
          formData.append(key, value);
        }
      });
      await axios.put("/accounts/api/settings/company/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": csrftoken,
        },
        withCredentials: true,
      });
      window.location.reload();
    } catch (err) {
      // handle error as needed
    }
  };
  if (loading) return <div>Loading...</div>;
  const getImagePreview = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value; // URL from backend
    if (value instanceof File) return URL.createObjectURL(value); // File object
    return "";
  };
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingsSidebar />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="card company-settings-new">
                <div className="card-body w-100">
                  <div className="content-page-header">
                    <h5>Company Settings</h5>
                  </div>
                  {!loading && currencyOptions?.currencies && (
                    <Form
                      onSubmit={onSubmit}
                      initialValues={initialValues}
                      render={({
                        handleSubmit,
                        submitting,
                        pristine,
                        values,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          {console.log(
                            "currencyOptions",
                            values,
                            currencyOptions?.currencies?.find(
                              (option) => option.value == values?.currency_type
                            )
                          )}
                          <div className="row">
                            {[
                              { name: "company_name", label: "Company Name" },
                              {
                                name: "company_address",
                                label: "Company Address",
                              },
                              { name: "company_email", label: "Company Email" },
                              {
                                name: "address_line_1",
                                label: "Address Line 1",
                              },
                              {
                                name: "address_line_2",
                                label: "Address Line 2",
                              },
                              { name: "country", label: "Country" },
                              { name: "state", label: "State" },
                              { name: "city", label: "City" },
                              { name: "pincode", label: "Pincode" },
                              { name: "phone_number", label: "Phone Number" },
                            ].map(
                              (field) =>
                                (field.name === "phone_number" && (
                                  <div className="col-lg-6 col-12">
                                    <div className="input-block mb-3">
                                      <label>Phone Number</label>

                                      <Field
                                        name="phone_number"
                                        validate={required}
                                      >
                                        {({ input, meta }) => (
                                          <>
                                            <PhoneInput
                                              defaultCountry="IN"
                                              value={input.value}
                                              onChange={input.onChange}
                                              placeholder="Enter Phone Number"
                                              className="input-block form-control"
                                              style={{
                                                display: "flex",
                                              }}
                                            />
                                            {meta.touched && meta.error && (
                                              <span
                                                style={{
                                                  color: "red",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {meta.error}
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                )) || (
                                  <div
                                    className="col-lg-6 col-12"
                                    key={field.name}
                                  >
                                    <Field
                                      name={field.name}
                                      validate={required}
                                    >
                                      {({ input, meta }) => (
                                        <div className="input-block mb-3">
                                          <label>{field.label}</label>
                                          <input
                                            {...input}
                                            type="text"
                                            className="form-control"
                                            placeholder={`Enter ${field.label}`}
                                          />
                                          {meta.touched && meta.error && (
                                            <span
                                              className="text-danger"
                                              style={{ fontSize: "12px" }}
                                            >
                                              {meta.error}
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    </Field>
                                  </div>
                                )
                            )}
                            <div className="col-lg-6 col-12">
                              <Field name="currency_type" validate={required}>
                                {({ input, meta }) => (
                                  <div className="input-block mb-3">
                                    <label>Currency</label>
                                    <Select
                                      {...input}
                                      options={
                                        currencyOptions?.currencies || []
                                      }
                                      placeholder="Select Currency"
                                      onChange={(option) => {
                                        console.log(option);
                                        input.onChange(option);
                                      }}
                                      value={
                                        input.value?.value
                                          ? currencyOptions?.currencies?.find(
                                              (option) =>
                                                option.value ===
                                                input.value.value
                                            )
                                          : currencyOptions?.currencies?.find(
                                              (option) =>
                                                option.value === input.value
                                            ) || null
                                      }
                                    />
                                    {meta.touched && meta.error && (
                                      <span
                                        className="text-danger"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                            <div
                              className="form-group-customer customer-additional-form"
                              style={{
                                marginLeft: "10px",
                              }}
                            >
                              <div className="row">
                                <h5 className="form-title">Bank Details</h5>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>
                                      Bank Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      name="bank_name"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Bank Name"
                                      validate={required}
                                    />
                                    <Error name="bank_name" />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>
                                      Branch{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      name="branch"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Branch Name"
                                      validate={required}
                                    />
                                    <Error name="branch" />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>
                                      Account Holder Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      name="account_holder_name"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Account Holder Name"
                                      validate={required}
                                    />
                                    <Error name="account_holder_name" />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>
                                      Account Number{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      name="account_number"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Account Number"
                                      validate={required}
                                    />
                                    <Error name="account_number" />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>
                                      IFSC{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      name="ifsc"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter IFSC Code"
                                      validate={required}
                                    />
                                    <Error name="ifsc" />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                  <div className="input-block mb-3">
                                    <label>SWIFT Code</label>
                                    <Field
                                      name="swift_code"
                                      component="input"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter SWIFT Code"
                                    />
                                    <Error name="swift_code" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-12 col-lg-12 col-12">
                              <div className="input-block mb-4">
                                <label>Company Icon</label>
                                <div className="input-block service-upload logo-upload mb-0">
                                  <div className="drag-drop">
                                    <h6 className="drop-browse align-center">
                                      <span className="text-info me-1">
                                        Click To Replace
                                      </span>{" "}
                                      or Drag and Drop
                                    </h6>
                                    <p className="text-muted">
                                      SVG, PNG, JPG (Max 800*400px)
                                    </p>
                                    <Field
                                      name="company_icon"
                                      validate={required}
                                    >
                                      {({ input, meta }) => (
                                        <>
                                          <input
                                            type="file"
                                            multiple={false}
                                            onChange={(e) =>
                                              input.onChange(e.target.files[0])
                                            }
                                          />
                                          {meta.touched && meta.error && (
                                            <span
                                              className="text-danger"
                                              style={{ fontSize: "12px" }}
                                            >
                                              {meta.error}
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </Field>
                                  </div>
                                  <span className="sites-logo">
                                    <img
                                      src={getImagePreview(
                                        values?.company_icon
                                      )}
                                      alt="upload"
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="btn-path text-end">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  disabled={submitting || pristine}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanySettings;
